export enum ParentComponent {
  PublicPage = 'publicPage',
  Preview = 'preview',
}

export enum RoutePath {
  Home = '/',
  Dashboard = '/dashboard',
  CreatePage = '/dashboard/admin/new',
  Analytics = '/dashboard/admin/analytics',
  AdminDashboard = '/dashboard/admin',
  TermsPage = '/terms',
  AuthSignup = '/auth/signup',
}

export const validateProtocol = (url: string) => {
  let newUrl = window.decodeURIComponent(url);
  newUrl = newUrl.trim().replace(/\s/g, '');

  if (!/^(ht)tps?:\/\//i.test(newUrl)) {
    return false;
  }

  return true;
};

export const validateDomain = (url: string) => {
  const newUrl = window.decodeURIComponent(url);

  return Boolean(newUrl.match(/(?:\.[a-zA-Z]{2,})+/));
};

export const validateNoWhitespace = (url: string) => {
  const whitespace = /\s/;
  return !whitespace.test(url);
};

export const getParsedURL = (url: string): string => {
  const hasProtocol = /^(\w+):/.test(url);
  return hasProtocol ? url : `https://${url}`;
};

/**
 * Redirect a browser, but only if not running a testing framework
 * this is so we can test redirect behavior without accessing a new origin
 */
export const redirect = (url: string) => {
  if (typeof window !== 'undefined') {
    if ((window as any).Cypress) {
      (window as any).nextUrl = url;
    } else {
      window.location.href = url;
    }
  }
};

export const isShopifyLink = (url: string) => {
  const tlds = ['linkpop.com', 'shopify.com'];

  try {
    const parsedUrl = new URL(url);
    return tlds.some((tld) => parsedUrl.hostname.endsWith(tld));
  } catch (err) {
    return false;
  }
};
